@if (show()) {
  <div
    animate.enter="fade-enter"
    style="--time: 200ms"
    animate.leave="fade-leave"
    class="w-screen h-screen fixed top-0 left-0 bg-black/70 z-5000 flex items-center justify-center"
  >
    <div class="loader"></div>
  </div>
}
